import { useStorage } from "@vueuse/core";

const store = useStorage("pod-store", {
  token: "",
  username: "",
  name: "",
  salesOfficeAuthority: "",
  reportAuthority: false,
  adminAuthority: false,
});

export { store };
